<template>
  <b-row>
    <b-col cols="12" lg="12">
      <b-card no-header>
        <template slot="header">
          User id:  {{ $route.params.id }}
        </template>
        <b-table class='table-hover' small fixed responsive="sm" :items="userData" :fields="fields">
          <template slot="value" slot-scope="data">
            <strong>{{data.value}}</strong>
          </template>
        </b-table>
        <template slot="footer">
          <b-button @click="goBack">Back</b-button>
          <b-button variant="primary" @click="$eventBus.$emit('editUserModal', user, clients, client_groups)">
            Edit user
          </b-button>
        </template>
      </b-card>
    </b-col>
    <user-modal />
  </b-row>
</template>

<script>
import UserModal from '@/views/modals/UserModal'
export default {
  name: 'User',
  components: {
    UserModal
  },
  props: {
    caption: {
      type: String,
      default: 'User id'
    },
  },
  data () {
    return {
      user: {},
      fields: [
        {key: 'key'},
        {key: 'value'}
      ],
      clients: [],
      client_groups: []
    }
  },

  mounted () {
    this.loadUserData()
  },

  methods: {
    goBack() {
      this.$router.go(-1)
    },

    loadUserData () {
      this.$http.get('/users/'+this.$route.params.id)
        .then(function(response){
          var data = response.data.data.attributes
          this.user = data
          if (this.user.dc_user_id) {
            this.$http.get('/clients?dc_user_id=' + this.user.dc_user_id)
              .then(function(response) {
                this.clients = response.data
              }.bind(this))
            this.$http.get('/client_groups?dc_user_id=' + this.user.dc_user_id)
              .then(function(response) {
                this.client_groups = response.data
              }.bind(this))
          }
        }.bind(this))
        .catch((e) => console.log(e))
    }
  },

  computed: {
    userData () {
      return Object.entries(this.user).map(function(arr) {
        var hash = { key: arr[0], value: arr[1] }
        return hash
      })
    }
  }
}
</script>

<style scoped>
.card-footer button.btn {
  margin-right: 5px;
}
</style>
